/* eslint-disable import/prefer-default-export */
import { aresConfig } from './sites/ares';
import { medsupplyConfig } from './sites/medsupply';
import { labbuildConfig } from './sites/labbuild';
import { scilogexConfig } from './sites/scilogex';
import { midlandConfig } from './sites/midland';
import { csiConfig } from './sites/csi';
import { symbioteConfig } from './sites/symbiote';
import { krackelerConfig } from './sites/krackeler';
import { airmasterConfig } from './sites/airmaster';
import { yamatoConfig } from './sites/yamato';

export const configTable = new Map(Object.entries(
  {
    ares: aresConfig,
    yamato: yamatoConfig,
    airmaster: airmasterConfig,
    medsupply: medsupplyConfig,
    labbuild: labbuildConfig,
    scilogex: scilogexConfig,
    midland: midlandConfig,
    csi: csiConfig,
    symbiote: symbioteConfig,
    krackeler: krackelerConfig,
  },
));
